import React, { useState } from "react"
import { Link } from "gatsby"
import * as styles from "./header.module.scss"
import Logo from "../../images/svgs/bchLogo.inline.svg"
import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from "@chakra-ui/react"
import LeftChevron from "../../images/svgs/chevron-left.inline.svg"

const Header = ({ siteTitle }) => {

    const url = typeof window !== 'undefined' ? window.location.href : '';

    const servicesUrls = [
        "/services/customer-and-user-experience/",
        "/services/design/",
        "/services/video-and-animation/",
        "/services/medical-writing/",
        "/services/editorial-and-compliance-checks/",
        "/services/digital-production/",
        "/services/project-management/",
        "/services/client-services/",
    ]

    const isServices = servicesUrls.some(el => url.includes(el))

    const { isOpen, onOpen, onClose } = useDisclosure()

    const [servicesMenu, setServicesMenu] = useState(false)


    return(
        <header className={isServices ? `${styles.header__services} ${styles.header}` : styles.header}>

            <div className="container">
                <div className={styles.navigation}>
                    <div className={styles.navigation__logo}>
                        <Link to="/" className="d-flex" aria-label="Visit Brandcast Health" title="Visit Brandcast Health">
                            <Logo width="270" height="63" />
                        </Link>
                    </div>

                    <div className={`${styles.navigation__links} d-none d-lg-block`}>
                        <Link activeClassName={styles.navigation__links__active} to="/about" aria-label="About" title="About">About</Link>
                        <Link activeClassName={styles.navigation__links__active} to="/strategy" aria-label="Strategy" title="Strategy">Strategy</Link>
                        <Link activeClassName={styles.navigation__links__active} to="/services" aria-label="Services" title="Services" partiallyActive={true}>Services</Link>
                        <Link activeClassName={styles.navigation__links__active} to="/resources" aria-label="Resources" title="Resources" partiallyActive={true}>Resources</Link>
                        <Link activeClassName={styles.navigation__links__active} to="/careers" aria-label="Careers" title="Careers" partiallyActive={true}>Careers</Link>
                        <Link activeClassName={styles.navigation__links__active} to="/contact" aria-label="Contact" title="Contact">Contact</Link>
                    </div>

                    <button className={`${styles.navigation__hamburger} d-flex d-lg-none`} onClick={onOpen} onKeyDown={onOpen} aria-label="hamburger menu">
                        <span></span>
                        <span></span>
                    </button>

                    <Drawer
                        isOpen={isOpen}
                        placement='right'
                        onClose={onClose}
                        size="full"
                        background="#3a4c55"
                    >
                        <DrawerOverlay/>
                        
                        <DrawerContent background="#3a4c55">
                            <DrawerCloseButton
                                variant='outline'
                                size='lg'
                                outline="none"
                                border="none"
                                color="#ffffff"
                                cursor="pointer"
                                className={styles.navigation__drawerBody__close}
                                onClick={() =>  setServicesMenu(false)}
                            />
                            <button 
                                className={`${styles.navigation__drawerBody__services__close} ${servicesMenu && styles.navigation__drawerBody__services__close__active}`}
                                onClick={() =>  setServicesMenu(false)}
                                onKeyDown={() =>  setServicesMenu(false)}
                            >
                                <LeftChevron />
                            </button>
                            <DrawerBody className={styles.navigation__drawerBody}>
                                <Link 
                                    activeClassName={styles.navigation__drawerBody__active}
                                    className={styles.navigation__drawerBody__links}
                                    to="/about"
                                >
                                    About
                                </Link>

                                <Link
                                    activeClassName={styles.navigation__drawerBody__active}
                                    className={styles.navigation__drawerBody__links}
                                    to="/strategy"
                                >
                                    Strategy
                                </Link>

                                <button 
                                    activeClassName={styles.navigation__drawerBody__active}
                                    className={styles.navigation__drawerBody__links}
                                    onClick={() =>  setServicesMenu(true)}
                                    onKeyDown={() =>  setServicesMenu(true)}
                                >
                                    Services
                                </button>

                                <Link 
                                    activeClassName={styles.navigation__drawerBody__active}
                                    className={styles.navigation__drawerBody__links}
                                    to="/resources" 
                                    partiallyActive={true}
                                >
                                    Resources
                                </Link>

                                <Link 
                                    activeClassName={styles.navigation__drawerBody__active}
                                    className={styles.navigation__drawerBody__links}
                                    to="/careers" 
                                    partiallyActive={true}
                                >
                                    Careers
                                </Link>

                                <Link 
                                    activeClassName={styles.navigation__drawerBody__active}
                                    className={styles.navigation__drawerBody__links}
                                    to="/contact"
                                >
                                    Contact
                                </Link>

                                <div className={`${styles.navigation__drawerBody__services} ${servicesMenu && styles.navigation__drawerBody__services__active}`}>
                                    <Link activeClassName={``} to="/services/customer-and-user-experience">
                                        Customer and User Experience
                                    </Link>
                                

                                    <Link activeClassName={``} to="/services/design">
                                        Design
                                    </Link>
                                

                                    <Link activeClassName={``} to="/services/video-and-animation">
                                        Video and Animation
                                    </Link>                            
                                

                                    <Link activeClassName={``} to="/services/medical-writing">
                                        Medical Writing
                                    </Link>       
                                

                                    <Link activeClassName={``} to="/services/editorial-and-compliance-checks">
                                        Editorial and Compliance
                                    </Link> 
                                

                                    <Link activeClassName={``} to="/services/digital-production">
                                        Digital Production
                                    </Link> 
                                

                                    <Link activeClassName={``} to="/services/project-management">
                                        Project Mangement
                                    </Link> 
                                

                                    <Link activeClassName={``} to="/services/client-services">
                                        Client Services
                                    </Link>    
                                </div>
                            </DrawerBody>
                        </DrawerContent>
                    </Drawer>


                </div>
            </div>
        </header>
    )

}

export default Header